import { apiFetch } from './client'
import { cached, invalidate } from './cache'

export interface PaymentType {
  id: string
  name: string
  price: number
  description?: string
  is_active: boolean
  sort_order: number
  created_at: string
  updated_at: string
}

export interface CreatePaymentTypeInput {
  name: string
  price: number
  description?: string
  sortOrder?: number
}

export interface UpdatePaymentTypeInput {
  name?: string
  price?: number
  description?: string
  sortOrder?: number
  isActive?: boolean
}

export const listPaymentTypes = () =>
  cached('payment-types', () => apiFetch<{ payment_types: PaymentType[] }>('/payment-types'), 300_000)

export const createPaymentType = async (data: CreatePaymentTypeInput) => {
  const r = await apiFetch<{ payment_type: PaymentType }>('/payment-types', { method: 'POST', body: JSON.stringify(data) })
  invalidate('payment-types')
  return r
}

export const updatePaymentType = async (id: string, data: UpdatePaymentTypeInput) => {
  const r = await apiFetch<{ payment_type: PaymentType }>(`/payment-types/${id}`, { method: 'PATCH', body: JSON.stringify(data) })
  invalidate('payment-types')
  return r
}

export const deletePaymentType = async (id: string) => {
  const r = await apiFetch<{ ok: boolean }>(`/payment-types/${id}`, { method: 'DELETE' })
  invalidate('payment-types')
  return r
}
